(function () {
  'use strict';
  if (window.__MAYTRIX_MOBILE_BUILDER__) return;
  var root = document.documentElement;
  var mobile = window.matchMedia('(max-width: 999px)');
  var steps = ['frame', 'center', 'sides', 'delivery'];
  var labels = ['Frame & Size', 'Center / Logo', 'Side Lighting', 'Delivery'];
  var active = 'frame';
  // Category IDs survive CPB step renaming and reordering.
  var anchors = {frame:'9Qos5yoFhBABVdL2vB4VBl0o', center:'rGBsXKwwThNiSwykhXb9lpED', sides:'-5rVa2YKJ10MFUHYFmKoRBJi', delivery:'BGKHZ-5NH8Q20vxd1xZh8vGR'};
  var scrollFrame = 0;
  var resizeObserver;
  var resizedPanels = [];
  var chevron = '<svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true" fill="none"><path d="m12 5-5 5 5 5" style="fill:none!important;stroke:currentColor" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var frame = 0;
  var panels = [];
  var builderObserver;
  var observedBuilder;
  var choices = {center: {open: false}, pattern: {open: false}};
  var centerSwitch = null;
  var sidesSwitch = null;
  var sideStyleSelector = '[data-category-id="-5rVa2YKJ10MFUHYFmKoRBJi"]';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function sideSelection(block) {
    var selected = block.querySelector(sideStyleSelector + ' .cpb-option[aria-pressed="true"]');
    return selected && selected.dataset.optionId;
  }

  function finishSidesSwitch() {
    var state = sidesSwitch;
    if (!state) return;
    sidesSwitch = null;
    clearTimeout(state.timer);
    if (state.animation) state.animation.cancel();
    ['height', 'overflow', 'overflow-anchor'].forEach(function (name) { state.block.style.removeProperty(name); });
    state.inert.forEach(function (value, element) { element.inert = value; });
    state.block.removeAttribute('aria-busy');
    state.block.removeAttribute('data-myx-sides-switch');
  }

  function beginSidesSwitch() {
    if (!enabled() || active !== 'sides') return;
    var block = document.querySelector('[data-myx-focus-section="sides"] .cpb-panel-categories-container');
    if (!block) return;
    finishSidesSwitch();
    var state = sidesSwitch = {block:block, height:block.getBoundingClientRect().height, selected:sideSelection(block), inert:new Map(), timer:0};
    block.style.height = state.height + 'px';
    block.style.overflow = 'hidden';
    block.style.overflowAnchor = 'none';
    block.setAttribute('aria-busy', 'true');
    block.dataset.myxSidesSwitch = 'out';
    updateSidesSwitch();
    state.timer = setTimeout(finishSidesSwitch, 4500);
  }

  function updateSidesSwitch() {
    var state = sidesSwitch;
    if (!state || state.block.dataset.myxSidesSwitch !== 'out') return;
    Array.from(state.block.children).forEach(function (element) {
      if (element.matches(sideStyleSelector)) return;
      if (!state.inert.has(element)) state.inert.set(element, element.inert);
      element.inert = true;
    });
    if (sideSelection(state.block) === state.selected) return;
    // Ongoing RGB/CPB updates must not keep postponing the controls' reveal.
    if (state.settling) return;
    state.settling = true;
    clearTimeout(state.timer);
    state.timer = setTimeout(function () {
      if (sidesSwitch !== state || !state.block.isConnected) { finishSidesSwitch(); return; }
      var block = state.block;
      block.style.height = 'auto';
      var height = block.getBoundingClientRect().height;
      block.style.height = height + 'px';
      block.dataset.myxSidesSwitch = 'in';
      if (!reduceMotion.matches) state.animation = block.animate(
        [{height:state.height+'px'}, {height:height+'px'}],
        {duration:280, easing:'cubic-bezier(.22,1,.36,1)'}
      );
      state.timer = setTimeout(function () { if (sidesSwitch === state) finishSidesSwitch(); }, 320);
    }, 100);
  }

  function finishCenterSwitch() {
    var state = centerSwitch;
    if (!state) return;
    centerSwitch = null;
    clearTimeout(state.timer);
    state.animations.forEach(function (animation) { animation.cancel(); });
    ['height', 'overflow', 'opacity', 'overflow-anchor'].forEach(function (name) { state.block.style.removeProperty(name); });
    state.block.removeAttribute('aria-busy');
    state.block.removeAttribute('data-myx-center-switch');
  }

  function beginCenterSwitch() {
    if (!enabled() || active !== 'center') return;
    var block = document.querySelector('#product-builder .myx-start-categories');
    if (!block) return;
    finishCenterSwitch();
    var state = centerSwitch = {block:block, height:block.getBoundingClientRect().height, animations:[], timer:0};
    block.style.height = state.height + 'px';
    block.style.overflow = 'hidden';
    block.style.overflowAnchor = 'none';
    block.setAttribute('aria-busy', 'true');
    block.dataset.myxCenterSwitch = 'out';
    block.style.opacity = '0';
    state.animations.push(block.animate([{opacity:1},{opacity:0}], {duration:reduceMotion.matches ? 70 : 140, easing:'ease-out'}));
    state.timer = setTimeout(finishCenterSwitch, 1800);
  }

  function settleCenterSwitch() {
    var state = centerSwitch;
    if (!state) return;
    clearTimeout(state.timer);
    state.timer = setTimeout(function () {
      if (centerSwitch !== state || !state.block.isConnected) { finishCenterSwitch(); return; }
      var block = state.block;
      state.animations.forEach(function (animation) { animation.cancel(); });
      block.style.height = 'auto';
      var height = block.getBoundingClientRect().height;
      block.style.height = height + 'px';
      block.style.opacity = '1';
      block.dataset.myxCenterSwitch = 'in';
      state.animations = [block.animate(
        reduceMotion.matches ? [{opacity:0},{opacity:1}] : [{height:state.height+'px', opacity:0}, {height:height+'px', opacity:1}],
        {duration:reduceMotion.matches ? 140 : 280, easing:'cubic-bezier(.22,1,.36,1)'}
      )];
      state.animations[0].finished.then(function () { if (centerSwitch === state) finishCenterSwitch(); }, function () {});
    }, 100);
  }

  function toggleChoice(key, category, content, button) {
    var state = choices[key], wasOpen = state.open;
    var before = content.getBoundingClientRect().height;
    if (state.animation) { state.animation.cancel(); state.animation = null; }
    state.open = !wasOpen;
    if (key !== 'center' || reduceMotion.matches || !content.animate) { queue(); return; }
    category.dataset.myxChoiceCollapsed = 'false';
    button.setAttribute('aria-expanded', String(state.open));
    content.inert = !state.open;
    content.style.overflow = 'hidden';
    var height = content.getBoundingClientRect().height;
    var animation = state.animation = content.animate(
      [{height:before+'px', opacity:wasOpen?1:0}, {height:(state.open?height:0)+'px', opacity:state.open?1:0}],
      {duration:220, easing:'cubic-bezier(.22,1,.36,1)', fill:'forwards'}
    );
    animation.finished.then(function () {
      if (state.animation !== animation) return;
      category.dataset.myxChoiceCollapsed = String(!state.open);
      animation.cancel(); state.animation = null; content.style.removeProperty('overflow'); queue();
    }, function () {});
  }

  function reviewOpen() {
    var q = new URLSearchParams(location.search);
    return document.body.matches('.myx-review-open,.myx-review-pending') ||
      q.get('review') === '1' || q.get('view') === 'maytrix-review';
  }

  function enabled() {
    return !reviewOpen() && panels.length === 4;
  }

  // A lightweight desktop-only thumb; the phone keeps its original native scrollbar.
  var desktopPointer = window.matchMedia('(min-width:1000px) and (hover:hover) and (pointer:fine)');
  var desktopScroll = {rail:null, thumb:null, column:null, timer:0, drag:null, range:0, travel:0, top:0, thumbHeight:0};

  function showDesktopScroll() {
    if (!desktopScroll.rail || desktopScroll.rail.hidden || !desktopPointer.matches || !enabled()) return;
    desktopScroll.rail.classList.add('is-scrolling');
    clearTimeout(desktopScroll.timer);
    desktopScroll.timer = setTimeout(function () {
      if (!desktopScroll.drag) desktopScroll.rail.classList.remove('is-scrolling');
    }, 550);
  }

  function syncDesktopScroll(column, columnRect, headerBottom, priceTop) {
    if (!desktopPointer.matches) {
      if (desktopScroll.rail) desktopScroll.rail.hidden = true;
      return;
    }
    if (!desktopScroll.rail) {
      var rail = document.createElement('div');
      rail.className = 'myx-desktop-scroll-indicator';
      rail.setAttribute('role', 'scrollbar');
      rail.setAttribute('aria-label', 'Design options scroll position');
      rail.setAttribute('aria-orientation', 'vertical');
      rail.setAttribute('aria-valuemin', '0');
      rail.setAttribute('aria-valuemax', '100');
      rail.setAttribute('aria-controls', column.id);
      rail.tabIndex = 0;
      var thumb = document.createElement('span');
      thumb.className = 'myx-desktop-scroll-indicator__thumb';
      thumb.setAttribute('aria-hidden', 'true');
      rail.appendChild(thumb);
      document.body.appendChild(rail);
      desktopScroll.rail = rail;
      desktopScroll.thumb = thumb;
      rail.addEventListener('keydown', function (event) {
        var scroller = desktopScroll.column;
        if (!scroller) return;
        var steps = {ArrowUp:-48, ArrowDown:48, PageUp:-scroller.clientHeight * .8, PageDown:scroller.clientHeight * .8};
        if (event.key === 'Home') scroller.scrollTop = 0;
        else if (event.key === 'End') scroller.scrollTop = desktopScroll.range;
        else if (Object.prototype.hasOwnProperty.call(steps, event.key)) scroller.scrollTop += steps[event.key];
        else return;
        event.preventDefault();
        showDesktopScroll();
      });
      function movePointer(event) {
        if (!desktopScroll.drag || !desktopScroll.travel) return;
        var position = event.clientY - desktopScroll.top - desktopScroll.drag.offset;
        desktopScroll.column.scrollTop = Math.max(0, Math.min(1, position / desktopScroll.travel)) * desktopScroll.range;
      }
      rail.addEventListener('pointerdown', function (event) {
        if (event.button !== 0 || !desktopScroll.range) return;
        event.preventDefault();
        var offset = event.target === thumb ? event.clientY - thumb.getBoundingClientRect().top : desktopScroll.thumbHeight / 2;
        desktopScroll.drag = {offset:offset};
        rail.setPointerCapture(event.pointerId);
        showDesktopScroll();
        movePointer(event);
      });
      rail.addEventListener('pointermove', movePointer);
      function endDrag() {
        if (!desktopScroll.drag) return;
        desktopScroll.drag = null;
        showDesktopScroll();
      }
      rail.addEventListener('pointerup', endDrag);
      rail.addEventListener('pointercancel', endDrag);
      rail.addEventListener('lostpointercapture', endDrag);
    }
    desktopScroll.column = column;
    var top = Math.max(columnRect.top, headerBottom) + 4;
    var height = Math.max(0, Math.min(columnRect.bottom, priceTop) - top - 4);
    var range = Math.max(0, column.scrollHeight - column.clientHeight);
    var thumbHeight = Math.min(height, Math.max(36, height * height / Math.max(1, range + height)));
    var travel = Math.max(0, height - thumbHeight);
    var progress = range ? Math.max(0, Math.min(1, column.scrollTop / range)) : 0;
    desktopScroll.range = range;
    desktopScroll.travel = travel;
    desktopScroll.top = top;
    desktopScroll.thumbHeight = thumbHeight;
    desktopScroll.rail.hidden = height < 40 || range === 0;
    function style(element, name, value) { if (element.style[name] !== value) element.style[name] = value; }
    style(desktopScroll.rail, 'top', top + 'px');
    style(desktopScroll.rail, 'left', (columnRect.right - 13) + 'px');
    style(desktopScroll.rail, 'height', height + 'px');
    style(desktopScroll.thumb, 'height', thumbHeight + 'px');
    style(desktopScroll.thumb, 'transform', 'translateY(' + (travel * progress) + 'px)');
    var percent = String(Math.round(progress * 100));
    if (desktopScroll.rail.getAttribute('aria-valuenow') !== percent) desktopScroll.rail.setAttribute('aria-valuenow', percent);
    if (!column.hasAttribute('data-myx-fading-scrollbar')) column.setAttribute('data-myx-fading-scrollbar', 'true');
  }

  var mobileScrollBoundsObserver;
  var mobileScrollBounds = [];
  function syncMobileOptionsScroll() {
    var column = document.querySelector('#product-builder .cpb-panels-container');
    var navigation = document.querySelector('.myx-preview-navigation');
    var price = document.querySelector('body > .myx-customizer-mobilebar');
    var on = enabled() && mobile.matches && column && navigation && price;
    if (!on) {
      root.classList.remove('myx-mobile-options-scroll');
      if (mobileScrollBoundsObserver) mobileScrollBoundsObserver.disconnect();
      mobileScrollBounds = [];
      return;
    }
    var navRect = navigation.getBoundingClientRect(), priceRect = price.getBoundingClientRect();
    if (!navRect.height || !priceRect.height) return;
    // Native scrolling belongs only to the visible options between the tabs and price.
    var visualBottom = window.visualViewport ? window.visualViewport.offsetTop + window.visualViewport.height : window.innerHeight;
    var bottom = Math.min(priceRect.top, visualBottom);
    function variable(name, value) { if (root.style.getPropertyValue(name) !== value) root.style.setProperty(name, value); }
    variable('--myx-mobile-options-top', Math.max(0, navRect.bottom) + 'px');
    variable('--myx-mobile-options-bottom', Math.max(0, window.innerHeight - bottom) + 'px');
    if (!root.classList.contains('myx-mobile-options-scroll')) {
      // Transfer the current options position when switching a loaded page to mobile.
      var position = Math.max(0, navRect.bottom - column.getBoundingClientRect().top);
      root.classList.add('myx-mobile-options-scroll');
      column.scrollTop = position;
      window.scrollTo(0, 0);
    }
    if (window.ResizeObserver && (mobileScrollBounds[0] !== navigation || mobileScrollBounds[1] !== price)) {
      if (!mobileScrollBoundsObserver) mobileScrollBoundsObserver = new ResizeObserver(queueScroll);
      mobileScrollBoundsObserver.disconnect();
      mobileScrollBoundsObserver.observe(navigation);
      mobileScrollBoundsObserver.observe(price);
      mobileScrollBounds = [navigation, price];
    }
  }

  function pinDesktopActions() {
    if (!enabled() || mobile.matches || !document.body.classList.contains('myx-desktop-customizer')) return;
    var column = document.querySelector('#product-builder .cpb-panels-container');
    if (!column) return;
    var anchor = column.querySelector('.myx-desktop-step-tabs') || column;
    var rect = anchor.getBoundingClientRect();
    function variable(name, value) { if (root.style.getPropertyValue(name) !== value) root.style.setProperty(name, value); }
    variable('--myx-desktop-actions-left', rect.left + 'px');
    variable('--myx-desktop-actions-width', Math.max(0, rect.width) + 'px');
    var bar = column.querySelector('.myx-customizer-actions-shell');
    variable('--myx-desktop-actions-height', (bar ? Math.ceil(bar.getBoundingClientRect().height) : 96) + 'px');
    // Bound the visible scroll track to the options between the pinned header and price.
    var columnRect = column.getBoundingClientRect();
    variable('--myx-desktop-scrollbar-top', Math.max(0, Math.ceil(rect.bottom - columnRect.top)) + 'px');
    variable('--myx-desktop-scrollbar-bottom', (bar ? Math.max(0, Math.ceil(columnRect.bottom - bar.getBoundingClientRect().top)) : 96) + 'px');
    syncDesktopScroll(column, columnRect, rect.bottom, bar ? bar.getBoundingClientRect().top : columnRect.bottom - 96);
  }

  function paint() {
    var on = enabled();
    if (reviewOpen()) { finishCenterSwitch(); finishSidesSwitch(); }
    document.body.classList.toggle('myx-builder-focus', !reviewOpen() && panels.length === 4);
    document.body.classList.toggle('myx-mobile-focus', on && mobile.matches);
    document.body.classList.toggle('myx-desktop-focus', on && !mobile.matches);
    root.classList.toggle('myx-mobile-builder-route', !reviewOpen());
    root.dataset.myxMobileStep = active;
    panels.forEach(function (panel, index) {
      var heading = panel.querySelector('.cpb-panel-title');
      if (heading) {
        var title = ['Frame & size', 'Center design', 'Side lighting', 'Delivery'][index];
        var hideTitle = false;
        if (heading.hasAttribute('data-myx-center-title-hidden') !== hideTitle) heading.toggleAttribute('data-myx-center-title-hidden', hideTitle);
        var progress = 'Step ' + (index + 1) + ' of 4';
        if (heading.dataset.myxMobileProgress !== progress) heading.dataset.myxMobileProgress = progress;
        if (heading.dataset.myxMobileTitle !== title) heading.dataset.myxMobileTitle = title;
        var desktopTitle = ['Frame & Size', 'Center Design', 'Lighting Style', 'Delivery'][index];
        if (heading.dataset.myxDesktopTitle !== desktopTitle) heading.dataset.myxDesktopTitle = desktopTitle;
        var headingLabel = on && mobile.matches ? progress + (title ? '. ' + title : '') : desktopTitle;
        if (headingLabel && heading.getAttribute('aria-label') !== headingLabel) heading.setAttribute('aria-label', headingLabel);
        if (!headingLabel && heading.hasAttribute('aria-label')) heading.removeAttribute('aria-label');
      }
      panel.removeAttribute('data-myx-focus-hidden');
      if (panel.inert) panel.inert = false;
      if (panel.getAttribute('role') !== 'region') panel.setAttribute('role', 'region');
      if (heading) {
        var headingId = 'myx-section-heading-' + panel.dataset.myxFocusSection;
        if (heading.id !== headingId) heading.id = headingId;
        if (panel.getAttribute('aria-labelledby') !== headingId) panel.setAttribute('aria-labelledby', headingId);
      }
    });
    if (on) document.querySelectorAll('.myx-customizer-quicknav [data-myx-customizer-step],.myx-desktop-step-tabs [data-myx-customizer-step]').forEach(function (tab) {
      var selected = tab.dataset.myxCustomizerStep === active;
      tab.classList.toggle('is-active', selected);
      if (selected && tab.getAttribute('aria-current') !== 'step') tab.setAttribute('aria-current', 'step');
      if (!selected && tab.hasAttribute('aria-current')) tab.removeAttribute('aria-current');
      tab.removeAttribute('aria-selected');
      if (tab.tabIndex !== 0) tab.tabIndex = 0;
    });
    syncMobileOptionsScroll();
    pinDesktopActions();
  }

  function scrollContext() {
    var column = document.querySelector('#product-builder .cpb-panels-container');
    var desktopScroll = column && (!mobile.matches || root.classList.contains('myx-mobile-options-scroll')) && /auto|scroll/.test(getComputedStyle(column).overflowY);
    var tabs = document.querySelector('.myx-desktop-step-tabs');
    var preview = document.querySelector('#product-builder .cpb-preview-container');
    var top = desktopScroll ? column.getBoundingClientRect().top : 0;
    if (!mobile.matches && tabs && tabs.getBoundingClientRect().height) top += tabs.getBoundingClientRect().height;
    // The preview becomes fixed as scrolling starts; reserve its height even at the page top.
    if (mobile.matches && !desktopScroll && preview) { top = preview.getBoundingClientRect().bottom; var nav = document.querySelector('.myx-preview-navigation'); if (nav) top += nav.getBoundingClientRect().height; }
    return {scroller:desktopScroll ? column : window, top:top + 16, position:desktopScroll ? column.scrollTop : window.scrollY};
  }

  function updateScrollStep() {
    scrollFrame = 0;
    if (!enabled()) return;
    syncMobileOptionsScroll();
    pinDesktopActions();
    var context = scrollContext(), key = steps[0];
    panels.forEach(function (panel, index) {
      if (panel.getBoundingClientRect().top <= context.top + 28) key = steps[index];
    });
    // A short final section cannot always reach the top of the scroll viewport.
    var scroller = context.scroller === window ? document.scrollingElement : context.scroller;
    if (scroller && scroller.scrollTop > 0 && scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 3) key = 'delivery';
    if (key !== active) { active = key; paint(); }
  }

  function queueScroll(event) {
    if (event && event.target === desktopScroll.column) showDesktopScroll();
    if (!scrollFrame) scrollFrame = requestAnimationFrame(updateScrollStep);
  }

  function select(key, fromSectionButton, keepTabFocus) {
    if (!enabled() || steps.indexOf(key) < 0) return false;
    finishCenterSwitch(); finishSidesSwitch();
    var panel = panels[steps.indexOf(key)];
    var context = scrollContext();
    active = key;
    paint();
    context.scroller.scrollTo({top:Math.max(0, context.position + panel.getBoundingClientRect().top - context.top), behavior:reduceMotion.matches ? 'auto' : 'smooth'});
    if (keepTabFocus) document.getElementById('myx-desktop-tab-' + key)?.focus({preventScroll:true});
    document.dispatchEvent(new CustomEvent('maytrix:mobile-section-change', {detail:{section:key}}));
    return true;
  }

  function enhanceChoices(builder) {
    function enhance(key, category, content, selected, title) {
      if (!category || !content || !selected) return;
      var state = choices[key];
      var label = selected.getAttribute('data-myx-choice-label') || selected.querySelector('.myx-pattern-label').textContent.trim();
      var changed = state.selected && state.selected !== label;
      if (changed) {
        state.open = false;
        if (state.animation) { state.animation.cancel(); state.animation = null; content.style.removeProperty('overflow'); }
      }
      state.selected = label;
      if (category.dataset.myxCompactChoice !== key) category.dataset.myxCompactChoice = key;
      if (!content.id) content.id = 'myx-' + key + '-choices';
      var button = category.querySelector('.myx-choice-toggle');
      if (!button) {
        button = document.createElement('button');
        button.type = 'button';
        button.className = 'myx-choice-toggle';
        button.innerHTML = '<span><strong></strong><small></small></span>';
        button.querySelector('strong').textContent = title;
        button.addEventListener('click', function () {
          var current = category.querySelector(key === 'center' ? '.cpb-category-content' : '.myx-pattern-grid');
          if (current) toggleChoice(key, category, current, button);
        });
        category.insertBefore(button, category.firstChild);
      }
      var summary = button.querySelector('small');
      var displayTitle = title;
      if (key === 'center' && category.dataset.myxUploadSelected !== String(label === 'Upload Logo')) category.dataset.myxUploadSelected = String(label === 'Upload Logo');
      if (button.querySelector('strong').textContent !== displayTitle) button.querySelector('strong').textContent = displayTitle;
      if (summary.textContent !== label) summary.textContent = label;
      if (button.getAttribute('aria-controls') !== content.id) button.setAttribute('aria-controls', content.id);
      if (button.getAttribute('aria-expanded') !== String(state.open)) button.setAttribute('aria-expanded', String(state.open));
      if (!state.animation && category.dataset.myxChoiceCollapsed !== String(!state.open)) category.dataset.myxChoiceCollapsed = String(!state.open);
      // Return keyboard focus to the selector before hiding the chosen card.
      if (changed && content.contains(document.activeElement)) button.focus({preventScroll: true});
      if (content.inert !== !state.open) content.inert = !state.open;
      if (changed && key === 'center') settleCenterSwitch();
    }
    var center = builder.querySelector('[data-category-id="rGBsXKwwThNiSwykhXb9lpED"]');
    if (center) {
      // Keep the native style choices visible before their dependent controls.
      var categories = center.parentElement;
      if (categories.firstElementChild !== center) categories.insertBefore(center, categories.firstElementChild);
      var starColor = categories.querySelector(':scope > [data-myx-extension-category="star-color"]');
      if (starColor && center.nextElementSibling !== starColor) center.insertAdjacentElement('afterend', starColor);
      var primary = categories.querySelector(':scope > .myx-primary-input');
      var beforePrimary = starColor || center;
      if (primary && beforePrimary.nextElementSibling !== primary) beforePrimary.insertAdjacentElement('afterend', primary);
      var star = center.dataset.myxStarryActive === 'true';
      var selected = center.querySelector(star ? '[data-myx-choice-label="Starlight"]' : '[data-myx-choice-group="center"][aria-pressed="true"]');
      var state = choices.center;
      if (selected) {
        var label = selected.getAttribute('data-myx-choice-label');
        var changed = state.selected && state.selected !== label;
        state.selected = label;
        if (changed) settleCenterSwitch();
      }
      state.open = true;
      if (state.animation) { state.animation.cancel(); state.animation = null; }
      ['data-myx-compact-choice', 'data-myx-choice-collapsed', 'data-myx-upload-selected'].forEach(function (name) {
        if (center.hasAttribute(name)) center.removeAttribute(name);
      });
      var toggle = center.querySelector('.myx-choice-toggle');
      if (toggle) toggle.remove();
      var content = center.querySelector('.cpb-category-content');
      if (content) {
        if (content.inert) content.inert = false;
        content.style.removeProperty('overflow');
      }
    }
    var pattern = builder.querySelector('[data-myx-extension-category="bar-pattern"]');
    enhance('pattern', pattern, pattern && pattern.querySelector('.myx-pattern-grid'),
      pattern && pattern.querySelector('[data-myx-bar-pattern][aria-checked="true"]'), 'Choose Your Light Pattern');
  }

  function enhanceShapeChoices(builder) {
    var category = builder.querySelector('[data-category-id="9Qos5yoFhBABVdL2vB4VBl0o"]');
    var rail = category && category.querySelector('.cpb-option__wrapper');
    if (!rail) return;
    var cards = Array.from(rail.children).filter(function (node) { return node.classList.contains('option'); });
    // Keep every native shape visible and selectable on desktop and mobile.
    if (cards.length !== 8) return;
    if (!rail.id) rail.id = 'myx-frame-shape-choices';
    if (rail.dataset.myxShapeChoices !== 'true') rail.dataset.myxShapeChoices = 'true';
    if (rail.dataset.myxShapesExpanded !== 'true') rail.dataset.myxShapesExpanded = 'true';
    rail.querySelectorAll('.myx-more-shapes').forEach(function (button) { button.remove(); });
    cards.forEach(function (card) { if (card.inert) card.inert = false; });
    var square = rail.querySelector('[data-option-id="1Ih2NEuHGAYzwnibSsUZWt80"]');
    if (square) {
      square.classList.remove('myx-recommended-choice');
      square.querySelectorAll(':scope > .myx-recommendation').forEach(function(badge){badge.remove();});
    }
  }

  function refineSectionLabels(builder) {
    var labels = {
      'ewsqpkHYBWFEbxeuQx2MyANc': 'Logo Outline',
      'PBO5FoiL7WyPoltf_adurqLd': 'Logo Lighting',
      'isXiGLkqYyvCvXqsv4l0QLOX': 'Font',
      'kU4ohHIkyE-mXjYFoFLSscwb': 'Text Size',
      'JTXoUcEXaLD_BdJU2yNZQFyU': 'Text Color',
      '9Qos5yoFhBABVdL2vB4VBl0o': 'Shape',
      'HLDWufZPnynTp9Z5O_n85-_k': 'Finish',
      'Kd1c_WSV_iUzEHP8raqt8zXx': 'Corner Style',
      'LB4oi7z56Ta0OZehKxWNh6o0': 'Size',
      'CQ5DSHGSBYKcjbeq1b8rf7MU': 'POPULAR SIZES',
      'Zs0mISKbbkrsanNymAIa6Zqf': 'POPULAR SIZES',
      'SAvhX7xAkC66xUbZf1toKKOW': 'Units',
      'aE4hNil-ULOoL_nuXhFekRZl': 'Custom Size',
      'dbIF9OR5ZazT43lgZsJxGlfh': 'Custom Size',
      'UrSKZIETH8x08xhpeuDYPDaQ': 'Light Color',
      '4qoRqj0Fds_iRKAoRemupDzi': 'Side Text',
      'DkvYo6CNoHB87aIPnRYEvu8v': 'Font',
      'QIKsaieim4U8XmKkOQ26QBAt': 'Text Color',
      'gMkDYozZJBDN8GYrPVJS--NR': 'LED Bar Color',
      'fD2kHs7C9MhutByPyc8Fup71': 'LED Bar Color',
      'BGKHZ-5NH8Q20vxd1xZh8vGR': 'Delivery Window',
      'm6Hu4SPi5Ld_sT6Vn2Ob8K9p': 'Payment Option'
    };
    Object.keys(labels).forEach(function (id) {
      var category = builder.querySelector('[data-category-id="' + id + '"]');
      var heading = category && category.querySelector('.cpb-category-title');
      var label = heading && heading.querySelector('.cpb-category-title__inner > span');
      if (!label) return;
      if (label.dataset.myxShortLabel !== labels[id]) label.dataset.myxShortLabel = labels[id];
      if (label.getAttribute('aria-label') !== labels[id]) label.setAttribute('aria-label', labels[id]);
      if (label.getAttribute('role') !== 'heading') { label.setAttribute('role', 'heading'); label.setAttribute('aria-level', '3'); }
      var style = getComputedStyle(label.parentElement);
      if (label.style.getPropertyValue('--myx-short-label-size') !== style.fontSize) label.style.setProperty('--myx-short-label-size', style.fontSize);
      if (label.style.getPropertyValue('--myx-short-label-height') !== style.lineHeight) label.style.setProperty('--myx-short-label-height', style.lineHeight);
    });
    function controlLabel(node, text, id) {
      if (!node) return;
      if (!node.hasAttribute('data-myx-control-label')) {
        var style = getComputedStyle(node);
        node.style.setProperty('--myx-control-label-size', style.fontSize);
        node.style.setProperty('--myx-control-label-height', style.lineHeight);
      }
      if (node.dataset.myxControlLabel !== text) node.dataset.myxControlLabel = text;
      if (node.getAttribute('aria-label') !== text) node.setAttribute('aria-label', text);
      if (id && node.id !== id) node.id = id;
    }
    controlLabel(builder.querySelector('label[for="myx-proportional-size"]'), 'Scale');
    [['kF4lvyIKrihWaPIn_2soR_O4', 'Width', 'myx-custom-width-label'], ['m_iFPB8o-mZvEqPZGLqLC2_m', 'Height', 'myx-custom-height-label'], ['JWL9jsM-zQ2w-fP_wEd6nexP', 'Width', 'myx-custom-width-cm-label'], ['xJ4pqSdWr_tLgm3ulA6kYXgp', 'Height', 'myx-custom-height-cm-label']].forEach(function (item) {
      var counter = builder.querySelector('.cpb-category-counter [data-option-id="' + item[0] + '"]');
      if (!counter) return;
      controlLabel(counter.querySelector('.cpb-counter__label'), item[1], item[2]);
      var input = counter.querySelector('input');
      if (input && input.getAttribute('aria-labelledby') !== item[2]) input.setAttribute('aria-labelledby', item[2]);
    });
  }

  function sync() {
    frame = 0;
    var builder = document.getElementById('product-builder');
    if (!builder) return;
    refineSectionLabels(builder);
    enhanceShapeChoices(builder);
    panels = steps.map(function (key) {
      var category = builder.querySelector('[data-category-id="' + anchors[key] + '"]');
      return category && category.closest('.cpb-panel-wrapper');
    }).filter(Boolean);
    if (panels.length === 4) panels.forEach(function (panel, index) {
      var id = 'myx-builder-panel-' + steps[index];
      if (panel.id !== id) panel.id = id;
      if (panel.dataset.myxFocusSection !== steps[index]) panel.dataset.myxFocusSection = steps[index];
      panel.querySelectorAll('.myx-mobile-section-nav').forEach(function (nav) { nav.remove(); });
    });
    var options = builder.querySelector('.cpb-panels-container');
    if (panels.length === 4 && options) {
      var tabs = options.querySelector('.myx-desktop-step-tabs');
      if (!tabs) {
        tabs = document.createElement('div');
        tabs.className = 'myx-desktop-step-tabs';
        tabs.setAttribute('role', 'navigation');
        tabs.setAttribute('aria-label', 'Design sections');
        var rail = document.createElement('div');
        rail.className = 'myx-desktop-step-tabs__rail';
        tabs.appendChild(rail);
        steps.forEach(function (key, index) {
          var button = document.createElement('button');
          button.type = 'button';
          button.id = 'myx-desktop-tab-' + key;
          button.dataset.myxCustomizerStep = key;
          button.setAttribute('aria-label', 'Jump to ' + labels[index] + ' options');
          button.setAttribute('aria-controls', panels[index].id);
          var label = document.createElement('span');
          label.textContent = labels[index];
          button.appendChild(label);
          rail.appendChild(button);
        });
        options.insertBefore(tabs, options.firstChild);
      }
    }
    var tabs = builder.querySelector('.myx-desktop-step-tabs');
    if (tabs && !tabs.querySelector('.myx-desktop-step-tabs__intro')) {
      var intro = document.createElement('div');
      intro.className = 'myx-desktop-step-tabs__intro';
      intro.innerHTML = '<h1>Your Logo, In Infinity</h1><p>Drag or swipe the 3D preview to rotate.</p>';
      tabs.appendChild(intro);
    }
    if (resizeObserver && panels.some(function (panel, index) { return resizedPanels[index] !== panel; })) {
      resizeObserver.disconnect();
      panels.forEach(function (panel) { resizeObserver.observe(panel); });
      if (options) resizeObserver.observe(options);
      if (tabs) resizeObserver.observe(tabs);
      resizedPanels = panels.slice();
    }
    builder.querySelectorAll('.myx-desktop-step-tabs [data-myx-customizer-step]').forEach(function (button) {
      if (button.querySelector('svg')) return;
      var mobileTab = document.querySelector('.myx-customizer-quicknav [data-myx-customizer-step="' + button.dataset.myxCustomizerStep + '"]');
      var icon = mobileTab && mobileTab.querySelector('svg');
      if (icon) button.insertBefore(icon.cloneNode(true), button.firstChild);
    });
    var preview = builder.querySelector('.cpb-preview-container');
    if (preview && !preview.querySelector('.myx-mobile-back')) {
      var back = document.createElement('a');
      back.className = 'myx-mobile-back';
      back.href = '/';
      back.innerHTML = chevron + '<span>Back</span>';
      back.setAttribute('aria-label', 'Back to Maytrix');
      preview.appendChild(back);
    }
    if (observedBuilder !== builder) {
      if (builderObserver) builderObserver.disconnect();
      builderObserver = new MutationObserver(function (records) {
        if (records.some(function (record) {
          return record.type === 'childList' ||
            (record.target.matches('[data-myx-choice-group="center"],[data-myx-bar-pattern],[data-myx-starry-active],[data-category-id="9Qos5yoFhBABVdL2vB4VBl0o"] .cpb-option,' + sideStyleSelector + ' .cpb-option') &&
             record.oldValue !== record.target.getAttribute(record.attributeName));
        })) queue();
      });
      builderObserver.observe(builder, {childList: true, subtree: true, attributes: true, attributeOldValue: true,
        attributeFilter: ['aria-pressed', 'aria-checked', 'data-myx-starry-active']});
      observedBuilder = builder;
    }
    enhanceChoices(builder);
    updateSidesSwitch();
    paint();
    queueScroll();
  }

  function queue() { if (!frame) frame = requestAnimationFrame(sync); }
  document.addEventListener('click', function (event) {
    if (!enabled() || !event.target.closest) return;
    var sectionButton = event.target.closest('[data-myx-navigate-section]');
    var tab = event.target.closest('.myx-customizer-quicknav [data-myx-customizer-step],.myx-desktop-step-tabs [data-myx-customizer-step]');
    if (!sectionButton && !tab) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    select(sectionButton ? sectionButton.dataset.myxNavigateSection : tab.dataset.myxCustomizerStep, !!sectionButton, !!tab?.closest('.myx-desktop-step-tabs'));
  }, true);
  document.addEventListener('keydown', function (event) {
    var tab = event.target.closest?.('.myx-desktop-step-tabs [data-myx-customizer-step]');
    if (!enabled() || !tab || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
    var index = steps.indexOf(tab.dataset.myxCustomizerStep);
    var next = event.key === 'Home' ? 0 : event.key === 'End' ? 3 : (index + (event.key === 'ArrowRight' ? 1 : 3)) % 4;
    event.preventDefault();
    select(steps[next], false, true);
  });
  function keyboard() {
    var v = window.visualViewport;
    var editing = document.activeElement && document.activeElement.matches('input:not([type=radio]):not([type=checkbox]),textarea,[contenteditable=true]');
    document.body.classList.toggle('myx-mobile-keyboard', !!(enabled() && mobile.matches && v && editing && v.height < window.innerHeight * .76));
  }
  function boot() {
    document.addEventListener('scroll', queueScroll, {capture:true, passive:true});
    if (window.ResizeObserver) resizeObserver = new ResizeObserver(queueScroll);
    document.addEventListener('maytrix:center-choice-transition', beginCenterSwitch);
    document.addEventListener('maytrix:sides-choice-transition', beginSidesSwitch);
    document.addEventListener('visibilitychange', function () { if (document.hidden) { finishCenterSwitch(); finishSidesSwitch(); } });
    window.addEventListener('pagehide', function () { finishCenterSwitch(); finishSidesSwitch(); });
    new MutationObserver(queue).observe(document.body, {attributes: true, attributeFilter: ['class']});
    var mount = new MutationObserver(queue);
    mount.observe(document.getElementById('MainContent') || document.body, {childList: true, subtree: true});
    ['CPB_ON_PRODUCT_MOUNTED', 'CPB_ON_OPTIONS_UPDATE'].forEach(function (name) { document.addEventListener(name, queue); document.body.addEventListener(name, queue); });
    window.addEventListener('popstate', queue);
    window.addEventListener('pageshow', queue);
    window.addEventListener('resize', queue);
    mobile.addEventListener('change', queue);
    desktopPointer.addEventListener('change', queue);
    document.addEventListener('focusin', keyboard);
    document.addEventListener('focusout', keyboard);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', keyboard);
      window.visualViewport.addEventListener('resize', queueScroll);
      window.visualViewport.addEventListener('scroll', queueScroll);
    }
    queue();
  }
  window.__MAYTRIX_MOBILE_BUILDER__ = {version: '2.0.3-shape-badge', select: select};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once: true});
  else boot();
  var uploadMedia = window.matchMedia('(max-width:999px)');
  function uploadCopy() {
    var textHeading = document.querySelector('#product-builder [data-category-id="SbHxRxgdGKf6gJA_Tm97efer"] .cpb-category-title__inner');
    if (textHeading) {
      if (textHeading.getAttribute('role') !== 'heading') textHeading.setAttribute('role', 'heading');
      if (textHeading.getAttribute('aria-level') !== '3') textHeading.setAttribute('aria-level', '3');
    }
    var category = document.querySelector('#product-builder [data-category-id="Qxp4cCZHBPSyjx8HBigw9Z0c"]');
    if (!category) return;
    var heading = category.querySelector('.cpb-category-title__inner');
    if (heading) {
      var label = heading.querySelector('span') || heading;
      if (label.textContent !== 'Upload your logo') label.textContent = 'Upload your logo';
      if (heading.getAttribute('role') !== 'heading') heading.setAttribute('role', 'heading');
      if (heading.getAttribute('aria-level') !== '3') heading.setAttribute('aria-level', '3');
    }
    category.querySelectorAll('.cpb-upload-title span').forEach(function (node) {
      var text = uploadMedia.matches ? 'Tap to upload your logo' : 'Click to upload your logo';
      if (node.textContent !== text) node.textContent = text;
    });
  }
  new MutationObserver(uploadCopy).observe(document.getElementById('product-builder')||document.body,{subtree:true,childList:true});
  uploadMedia.addEventListener('change',uploadCopy); uploadCopy();
})();

/* Presentation only: preserve CPB option IDs, dimensions and pricing. */
(function () {
  'use strict';
  var selector = '[data-category-id="Zs0mISKbbkrsanNymAIa6Zqf"], [data-category-id="CQ5DSHGSBYKcjbeq1b8rf7MU"]';
  var scheduled = 0;
  function sync() {
    scheduled = 0;
    var root = document.getElementById('product-builder');
    if (!root) return;
    root.querySelectorAll(selector).forEach(function (category) {
      if (category.getAttribute('data-myx-compact-sizes') !== 'true') category.setAttribute('data-myx-compact-sizes', 'true');
      category.querySelectorAll('.cpb-option[data-option-id]').forEach(function (card) {
        var label = Array.from(card.children).find(function (node) {
          return node.tagName === 'DIV' && !node.classList.contains('cpb-option-description');
        });
        var match = label && label.textContent.trim().match(/^(Classic|Statement|Gallery|Feature|Grand)\s*[—–-]\s*(.+)$/);
        if (!match) return;
        if (label.getAttribute('data-myx-size-name') !== match[1]) label.setAttribute('data-myx-size-name', match[1]);
        if (label.getAttribute('data-myx-size-dimensions') !== match[2]) label.setAttribute('data-myx-size-dimensions', match[2]);
        var accessibleLabel = match[1] + ', ' + match[2];
        if (card.getAttribute('aria-label') !== accessibleLabel) card.setAttribute('aria-label', accessibleLabel);
      });
    });
    var mode = root.querySelector('[data-category-id="LB4oi7z56Ta0OZehKxWNh6o0"] [data-option-id="ChhzZNLNHc6HoBDjegeEYT4G"] > div');
    if (mode && mode.textContent.trim() === 'Signature Sizes') mode.textContent = 'Popular Sizes';
  }
  function queue() { if (!scheduled) scheduled = requestAnimationFrame(sync); }
  function boot() {
    var root = document.getElementById('product-builder');
    if (!root) return;
    new MutationObserver(queue).observe(root, {childList: true, subtree: true, characterData: true});
    queue();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true});
  else boot();
})();
